// extracted by mini-css-extract-plugin
export var card = "_n5-0";
export var content = "_n5-2";
export var details = "_n5-3";
export var icon = "_n5-1";
export var iconBlue = "_n5-5";
export var iconBrand = "_n5-4";
export var iconGrayBlue = "_n5-6";
export var iconGreen = "_n5-7";
export var iconIndigo = "_n5-8";
export var iconOrange = "_n5-9";
export var iconPurple = "_n5-a";
export var iconRed = "_n5-b";
export var iconWarning = "_n5-c";